import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChatStreamWordsSubscriptionVariables = Types.Exact<{
  chat_id?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ChatStreamWordsSubscription = { __typename?: 'subscription_root', chat_stream_words: Array<{ __typename?: 'chat_stream_words', word: string, is_final?: boolean | null, has_error?: boolean | null, error_message?: string | null }> };


export const ChatStreamWordsDocument = gql`
    subscription chatStreamWords($chat_id: String) {
  chat_stream_words(where: {chat_id: {_eq: $chat_id}}, order_by: {position: asc}) {
    word
    is_final
    has_error
    error_message
  }
}
    `;

/**
 * __useChatStreamWordsSubscription__
 *
 * To run a query within a React component, call `useChatStreamWordsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatStreamWordsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatStreamWordsSubscription({
 *   variables: {
 *      chat_id: // value for 'chat_id'
 *   },
 * });
 */
export function useChatStreamWordsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChatStreamWordsSubscription, ChatStreamWordsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatStreamWordsSubscription, ChatStreamWordsSubscriptionVariables>(ChatStreamWordsDocument, options);
      }
export type ChatStreamWordsSubscriptionHookResult = ReturnType<typeof useChatStreamWordsSubscription>;
export type ChatStreamWordsSubscriptionResult = Apollo.SubscriptionResult<ChatStreamWordsSubscription>;